import { Injectable, ChangeDetectorRef } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { debounceTime, filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class InputMatchingService {

  setupInputWatcher(
    control: Observable<any>,
    ignoreChanges: () => boolean,
    loadMatchingInput: (searchString: string) => void,
    debounceTimeMs: number = 300
  ): Subscription {
    return control.pipe(
      debounceTime(debounceTimeMs),
      filter(value => value != null && ('' + value).trim().length > 0 && !ignoreChanges())
    ).subscribe(value => {
      loadMatchingInput('' + value);
    });
  }

  clearMatchingInputOnClick(
    event: MouseEvent,
    inputFieldWrapper: HTMLElement,
    clearMatchingInput: () => void,
    cdr: ChangeDetectorRef
  ): void {
    if (inputFieldWrapper && !inputFieldWrapper.contains(event.target as Node)) {
      clearMatchingInput();
      cdr.detectChanges();
    }
  }

  loadMatchingInput<T>(
    searchString: string,
    fetchMatchingCodes: (searchString: string) => Observable<T[]>,
    updateMatchingInput: (codes: T[]) => void,
    cdr: ChangeDetectorRef
  ): void {
    updateMatchingInput([]); 
    cdr.detectChanges();

    fetchMatchingCodes(searchString).subscribe({
      next: codes => {
        updateMatchingInput(codes.slice(0, 5));
        cdr.detectChanges();
      },
      error: () => {
        updateMatchingInput([]);
        cdr.detectChanges();
      },
    });
  }

  unsubscribe(subscription: Subscription): void {
    if (subscription) {
      subscription.unsubscribe();
    }
  }
}
